import _isNil from "lodash/isNil";
import createMemoizedSelector from '../createMemoizedSelector';
import getAutoDetectedSublibrarySelections from './getAutoDetectedSublibrarySelections';
import { getEmptySublibrarySelections, getMergedSublibrarySelections as getMergedSublibrarySelectionsForMatcher } from '../../../utils/secondary-analysis/fastqMatcher';
var getMergedSublibrarySelectionsSelector = function getMergedSublibrarySelectionsSelector() {
  return function (analysisState, autoDetectedSublibrarySelections) {
    var _analysisState$files$, _analysisState$files;
    if (_isNil(analysisState)) return getEmptySublibrarySelections();
    return getMergedSublibrarySelectionsForMatcher(autoDetectedSublibrarySelections, (_analysisState$files$ = (_analysisState$files = analysisState.files) === null || _analysisState$files === void 0 ? void 0 : _analysisState$files.sublibraryUserSelections) !== null && _analysisState$files$ !== void 0 ? _analysisState$files$ : getEmptySublibrarySelections());
  };
};
export default createMemoizedSelector(getMergedSublibrarySelectionsSelector, {
  inputSelectors: [{
    func: function func(secondaryAnalysisId) {
      return function (state) {
        return state[secondaryAnalysisId];
      };
    },
    paramsIngest: function paramsIngest(secondaryAnalysisId) {
      return [secondaryAnalysisId];
    }
  }, {
    func: getAutoDetectedSublibrarySelections,
    paramsIngest: function paramsIngest(secondaryAnalysisId) {
      return [secondaryAnalysisId];
    }
  }]
});